'use strict';

module.exports = function (string) {
  console.log(string);
};